export default "__VITE_ASSET__BTn521Dm__"